import { KontableComponent } from './../../../../modules/UIKit/components/kontable/kontable.component';
import { CalendarTranslateService } from './../../../../modules/UIKit/services/calendarTranslate.service';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
  selector: 'app-loyalty-closed-reservations',
  templateUrl: './loyalty-closed-reservations.component.html',
  styleUrls: ['./loyalty-closed-reservations.component.css']
})
export class LoyaltyClosedReservationsComponent implements OnInit {
  dateFilter = KontableComponent.DateFilter;

  @Input() reservations: any[];
  @Output() onShowDetails: EventEmitter<any> = new EventEmitter();
  @ViewChild('closedReservationTable') closedReservationTable: any;

  constructor(
    public calendarTranslateService: CalendarTranslateService,
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservations/loyalty-closed-reservations/loyalty-closed-reservations.component.ts